import { createSelector } from 'reselect'

const getQuickBookConnection = ({ dataIntegration }) => dataIntegration.quickBookData
const getCreatingQuickBookConnection = ({ dataIntegration }) =>
  dataIntegration.creatingQuickBookConnection

const dataIntegrationSelectors = {
  getQuickBookConnection: createSelector(
    [getQuickBookConnection],
    (quickBookData) => quickBookData,
  ),
  getCreatingQuickBookConnection: createSelector(
    [getCreatingQuickBookConnection],
    (creatingQuickBookConnection) => creatingQuickBookConnection,
  ),
}

export default dataIntegrationSelectors
